
import { withStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Action from "components/ActionPopOver";
import Loader from "components/loader/Loader";
import React from 'react';
import ScheduleReportUser from "./ScheduleReportUser";
import { fontConfig } from "theme/fontConfig";

const TableCellBody = withStyles((theme) => ({
	root: {
		height: "65px",
		padding: "0px 20px",
		fontFamily: fontConfig.GeneralTableCellBodyFont.family,
		fontSize: "12px",
		color: "#4F4F4F",
	},
}))(TableCell);


const ScheduleReportTableBody = ({ loading, scheduleList,onDeleteSchedule, openCreateSchedule }) => {
  return (
    <TableBody
      className="tran-table-body"
      style={{
        backgroundColor: "white",
      }}
    >
      {loading ? (
        <TableRow>
          <TableCell colSpan={10} align="center">
            <div
              className="user__loader"
              style={{ height: "320px" }}
            >
              <Loader />
            </div>
          </TableCell>
        </TableRow>
      ) : scheduleList?.length === 0 ? (
        <TableRow>
          <TableCell colSpan={10} align="center">
            <h6 style={{ height: "320px", marginTop: "100px" }}>
              No Data Found
            </h6>
          </TableCell>
        </TableRow>
      ) : (
        scheduleList?.map((row, i) => (
            <TableRow sx={{ "& > *": { borderBottom: "unset" } }} key={row?.id}>
              <TableCellBody align="left">{row?.eventTypeName}</TableCellBody>
              <TableCellBody align="left">{row?.groupName}</TableCellBody>
              <TableCellBody className="account-header main-width-class" align="left" onClick={() => { }}>
                {row?.numberOfParticipant}
              </TableCellBody>
              <TableCellBody align="left">{row?.frequencyUnit}</TableCellBody>
              <TableCellBody align="left" className="images-blocks">
                {row?.active1 === 1 ? <CheckCircleIcon color="primary" /> : <CancelIcon color="primary" />}
              </TableCellBody>
              <TableCellBody align="left" className="images-blocks">
                {row?.commingSoon === 1 ? (
                  <CheckCircleIcon color="primary" />
                ) : (
                  <CancelIcon color="primary" />
                )}
              </TableCellBody>
              <TableCellBody align="left" className="images-blocks">
                {row?.followup === 1 ? <CheckCircleIcon color="primary" /> : <CancelIcon color="primary" />}
              </TableCellBody>
              <TableCellBody className="exp-action-head main-width-class sticky-body-column" align="right">
                <div style={{ cursor: "pointer", paddingleft: "0px" }}>
                   <Action
                    action='class'
                    style={{ width: '16px' }}
                    onEditViewClick={() => openCreateSchedule(row)}
                    onClassDeleteClick={() => onDeleteSchedule(row)}
                  />
                </div>
              </TableCellBody>
            </TableRow>
        )
        ))}
    </TableBody>
  )
}

export default ScheduleReportTableBody